import trimStart from 'lodash/trimStart';

export default v => (!v ? v : trimStart(trimStart(v.replace(/\s+/g, ' '))));
